var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestimonialGradient = function SvgTestimonialGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 107 567"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h567v107H0z",
    transform: "rotate(90 53.5 53.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h567v107H0z",
    transform: "rotate(90 53.5 53.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 0h567v107H0z",
    transform: "rotate(90 53.5 53.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 0h567v107H0z",
    transform: "rotate(90 53.5 53.5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-174.349 286.14 39.508)scale(310.112 118.142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA12F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(132.25919 96.17977 -141.62451 194.75138 283.5 41.598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2059",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(10.049 -324.964 81.208)scale(344.505 166.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E36F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#9E36F1",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.638 172.06 80.895)scale(129.578 193.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C799",
    stopOpacity: 0
  })))));
};
export { SvgTestimonialGradient as ReactComponent };
export default "data:image/svg+xml;base64,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";